export default __webpack_public_path__ + "static/itpodnik-8f38a28c6932bb3c4dc613d0555ac31c.png";